import * as api_config from '../../config/api_config'

let address = `${api_config.ADDRESS}/admin`

export default {
    getCategoriesTree(axios) {
        return axios.get(`${address}/categories/categories_tree`, {headers: api_config.HEADERS});
    }
}
